// extracted by mini-css-extract-plugin
export default {"container":"home-page-periodelibre_container__1hsbD","blocks":"home-page-periodelibre_blocks__6MY1n"};